import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaDecisions = React.lazy(() =>
    import('../NebulaDecisions')
);
const nebulaDecisionsRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_DECISIONS_PAGE,
        element: <NebulaDecisions />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaDecisionsRoutesRegistry;
